import BaseRoute from 'seshy/routes/base';

export default class AuthenticatedIssuesRoute extends BaseRoute {}
